import { MESSAGE_ERREUR_ADRESSE_OBLIGATOIRE, MESSAGE_ERREUR_CODEPOSTAL_OBLIGATOIRE, 
  MESSAGE_ERREUR_NOMSOCIETE_OBLIGATOIRE, MESSAGE_ERREUR_PAYS_OBLIGATOIRE, MESSAGE_ERREUR_SIREN_OBLIGATOIRE, MESSAGE_ERREUR_SIREN_FORMAT, MESSAGE_ERREUR_TYPECOMPTESOCIETE_OBLIGATOIRE, 
  MESSAGE_ERREUR_TYPESECTEURACTIVITE_OBLIGATOIRE, MESSAGE_ERREUR_VILLE_OBLIGATOIRE } from '../../data/message-erreurs-form';
import * as Yup from 'yup';
import { webSiteSchema } from './siteWebSchema';
import { FRANCE_ET_ASSIMILES_IDS } from '../../utils/helpers';

export const getOrganisationSchema = (sirenApiError?: string | null) => {
  return Yup.object().shape({
    Siren: Yup
    .string()
    .when('IdPays', ([idPays], schema) => {
      return idPays && FRANCE_ET_ASSIMILES_IDS.includes(idPays)
        ? schema.required(MESSAGE_ERREUR_SIREN_OBLIGATOIRE)
            .matches(/^\d{9}$/, MESSAGE_ERREUR_SIREN_FORMAT)
            .test("api-validation", sirenApiError || "", function(value) {
              // Si une erreur API existe, le champ est invalide
              if (sirenApiError && value && value.length === 9) {
                return this.createError({ message: sirenApiError });
              }
              return true;
            })
        : schema.notRequired();
    }),
    RaisonSocialeSiren: Yup
    .string()
    .notRequired(),
    IdTypeCompteSociete: Yup
    .number()
    .required(MESSAGE_ERREUR_TYPECOMPTESOCIETE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_TYPECOMPTESOCIETE_OBLIGATOIRE),
    IdSecteurActivite: Yup
    .number()
    .required(MESSAGE_ERREUR_TYPESECTEURACTIVITE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_TYPESECTEURACTIVITE_OBLIGATOIRE),
    RaisonSociale: Yup
    .string()
    .required(MESSAGE_ERREUR_NOMSOCIETE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_NOMSOCIETE_OBLIGATOIRE),
    Ville: Yup
    .string()
    .required(MESSAGE_ERREUR_VILLE_OBLIGATOIRE)
    .typeError(MESSAGE_ERREUR_VILLE_OBLIGATOIRE),
    SiteInternet: webSiteSchema(),
    //.required(MESSAGE_ERREUR_SITEINTERNET_OBLIGATOIRE)
    //.typeError(MESSAGE_ERREUR_SITEINTERNET_OBLIGATOIRE),
    Adresse: Yup
      .string()
      .required(MESSAGE_ERREUR_ADRESSE_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_ADRESSE_OBLIGATOIRE),
      CodePostal: Yup
      .string()
      .notRequired()
      .typeError(MESSAGE_ERREUR_CODEPOSTAL_OBLIGATOIRE), 
      IdPays: Yup
      .number()
      .required(MESSAGE_ERREUR_PAYS_OBLIGATOIRE)
      .typeError(MESSAGE_ERREUR_PAYS_OBLIGATOIRE)
  });
};

// Version par défaut sans erreur API (rétrocompatibilité)
export const OrganisationSchema = getOrganisationSchema();

